<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  /* padding: 20px; */
  overflow-y: scroll;
}

.margin{
  color: white;
  margin-top: 50px;
  text-align: center;
}

.card{
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 20px;
  margin: 10px 10px 50px 10px;
  padding: 1px 1px 20px 1px;
}
.question{
  margin: 28px;
}
.slider{
  padding: 0 20px;
}

.text{
  display: grid;
  grid-template-columns: 16px auto auto 16px;
  font-size: 16px;
  margin: 5px;
}
.left-arrow{
  grid-column: 1;
}
.left-text{
  grid-column: 2;
}
.right-text{
  grid-column: 3;
  text-align: right;
}
.right-arrow{
  grid-column: 4;
}
.buttons{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  background-color: black;
}
.has-buttons{
  height: 120px;
}

</style>

<div class="bg">
  <div class="title-signup">Match Questions</div>
  
  {#each Questions as item}
  
    {#if item.type == 'scale0-5'}
    
      {#if showAllHelper(item)}
      
      <div class="card">
        
        <div class="question">Q: {item.question}</div>
        <div class="question">A: { item.selected[0] != 0 ? item.answers[ item.selected[0] - 1 ] : 'No Answer' }</div>
        
        <div class="slider">
          <RangeSlider id="matchQuestion1" min="{0}" max="{5}" pips bind:values="{item.selected}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
        </div>
        
        <div class="text">
          <div class="left-arrow"><i class="icon-arrow_left"></i></div>
          <div class="left-text">{item.leftText}</div>
          <div class="right-text">{item.rightText}</div>
          <div class="right-arrow"><i class="icon-arrow_right"></i></div>
        </div>
        
      </div>
      
      {/if}
    
    {/if}
  
  {/each}

  <div class="has-buttons"></div>
</div>


<div class="buttons">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";

import Questions from "../../../../helpers/Questions.js";


let matchQuestion1 = [0];


function showAllHelper(item) {
  if (item.default == true) {
    return true;
  }
  
  return false;
}


function next() {
  push("/signup/profile/personal/thankyou");
}



</script>